module.exports = __webpack_public_path__ + "static/security-ac634c46da8a1fb811848861af9c93d9.png";